import stagingLinks from './links/stagingLinks';
import productionLinks from './links/productionLinks';

console.debug('Pricing breakdown section - node env:', process.env.NODE_ENV);

export const IS_STAGING_PAGE =
  window.location.pathname.includes('test_pages') ||
  new URLSearchParams(window.location.search).get('environment') === 'development' ||
  process.env.NODE_ENV === 'development';

const links = IS_STAGING_PAGE ? stagingLinks : productionLinks;

export interface LinksProps {
  [key: string]: {
    [key: string]: string;
  };
}

export default links as LinksProps;
